const HealthInsurances = Object.freeze({
  aokPlus: "aokPlus",
  aokRps: "aokRps",
  mobil: "mobil",
})

export default HealthInsurances
